import { render, staticRenderFns } from "./ScorerTableMimir.vue?vue&type=template&id=744029a5&scoped=true&"
import script from "./ScorerTableMimir.vue?vue&type=script&lang=js&"
export * from "./ScorerTableMimir.vue?vue&type=script&lang=js&"
import style0 from "./ScorerTableMimir.vue?vue&type=style&index=0&id=744029a5&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "744029a5",
  null
  
)

export default component.exports